import { useLocalSearchParams, usePathname, useRouter } from 'expo-router';
import { ScrollView, View } from 'react-native';
import { useSearchParams } from 'react-router-dom';

import { DatabaseTable } from '@/components/databases/DatabaseTable.web';
import { PageView } from '@/components/editor/PageView.web';
import { DocumentTitle } from '@/components/layout/DocumentTitle';
import { searchTargetHref } from '@/lib/search/search-navigation';

import { SearchEmptyState } from './SearchEmptyState.web';

function SearchDatabaseView({ databaseId }: { databaseId: string }) {
  const router = useRouter();
  const [searchParams] = useSearchParams();
  const q = searchParams.get('q') ?? '';

  return (
    <ScrollView
      className="min-h-0 flex-1 bg-surface"
      contentContainerClassName="min-w-0 grow"
      showsVerticalScrollIndicator
    >
      <DocumentTitle title="Search" />
      <View className="cs-db-page min-w-0 w-full max-w-full px-page py-page-y">
        <DatabaseTable
          databaseId={databaseId}
          onOpenRow={(rowId) => {
            router.push(
              searchTargetHref(
                { containerId: rowId, containerType: 'page', topBlockId: rowId },
                { query: q },
              ),
            );
          }}
        />
      </View>
    </ScrollView>
  );
}

export function SearchShell() {
  const pathname = usePathname();
  const { id } = useLocalSearchParams<{ id?: string }>();
  const pageId = typeof id === 'string' ? id : id?.[0];

  if (pathname.startsWith('/search/database/') && pageId) {
    return <SearchDatabaseView databaseId={pageId} />;
  }

  if (pathname.startsWith('/search/page/') && pageId) {
    return <PageView pageId={pageId} trackRecents />;
  }

  return <SearchEmptyState />;
}
